// extracted by mini-css-extract-plugin
export default {"snsBtnlist":"ListSNS_snsBtnlist__Y-Vd6","snsBtn":"ListSNS_snsBtn__QTIwl"};